export enum StorefrontError {
  STOREFRONT_ALREADY_EXISTS = 'STOREFRONT_ALREADY_EXISTS',
  STOREFRONT_NOT_FOUND = 'STOREFRONT_NOT_FOUND',
  SLUG_ALREADY_TAKEN = 'SLUG_ALREADY_TAKEN',
  COLLECTION_NOT_FOUND = 'COLLECTION_NOT_FOUND',
  DUPLICATE_COLLECTION_ORDER = 'DUPLICATE_COLLECTION_ORDER',
  INVALID_PRODUCT_IDS = 'INVALID_PRODUCT_IDS',
}
